import { apiRequest } from '@/utils/request'

// 获取系统配置
export function getSystemConfig(queryParam) {
  return apiRequest({
    url: '/SystemConfig/Get',
    method: 'get',
    params: queryParam
  })
}
